"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsDeltaApi = void 0;
const translationsApi_1 = require("./translationsApi");
const translationsVersion_1 = require("../translationsVersion");
const core_1 = require("../../core");
const getTranslationsDataType = (data) => {
    return data
        ? {
            entries: data.entries,
            language: data.language,
            version: data.version,
        }
        : undefined;
};
const getVersion = ({ packageVersion, language }) => {
    return {
        language,
        version: packageVersion,
    };
};
const LOG_PREFIX = '[Api delta translations]';
class TranslationsDeltaApi extends translationsApi_1.TranslationsApi {
    constructor(params) {
        super(params);
    }
    get(currentVersion_1) {
        return __awaiter(this, arguments, void 0, function* (currentVersion, forced = false) {
            var _a;
            try {
                const requestUrl = this.getDownloadUrl(currentVersion);
                const { data: versionData } = yield this.xhr.GET(requestUrl);
                const urlRaw = (_a = versionData === null || versionData === void 0 ? void 0 : versionData.deltaUrl) !== null && _a !== void 0 ? _a : versionData.downloadUrl;
                if (translationsVersion_1.TranslationsVersion.isEqual(currentVersion, getVersion(versionData)) && !forced) {
                    core_1.Log.info(LOG_PREFIX + ' - current version is the same that the last on api');
                    return Promise.resolve(undefined);
                }
                try {
                    const { data: translationsResponse } = yield this.xhr.GET(urlRaw);
                    core_1.Log.info(LOG_PREFIX + ' - Successfully downloaded translations');
                    return Promise.resolve(getTranslationsDataType(translationsResponse));
                }
                catch (e) {
                    core_1.Log.warn(LOG_PREFIX + ' - Bad Response downloading translations package');
                    return Promise.reject(e);
                }
            }
            catch (e) {
                core_1.Log.warn(LOG_PREFIX + ' - failure getting translations url');
                return Promise.reject(e);
            }
        });
    }
}
exports.TranslationsDeltaApi = TranslationsDeltaApi;
//# sourceMappingURL=translationsDeltaApi.js.map